import React from "react";
import { HistoryItem, HistoryItemTitle, TimestampRow } from "./styledComponents";
import { AuditEditLabel } from "./AuditEditLabel";

export type AuditHistoryItemProps = {
  label: string;
  date: string;
  author?: string;
  deleted?: boolean;
  content: React.ReactNode;
};

/**
 * Reusable history item component with divider at item level.
 * Displays edit label, date, optional author, and content (usually timestamp display).
 */
export const AuditHistoryItem = ({
  label,
  date,
  author,
  deleted = false,
  content,
}: AuditHistoryItemProps) => {
  return (
    <HistoryItem deleted={deleted}>
      <HistoryItemTitle deleted={deleted}>
        <AuditEditLabel label={label} date={date} author={author} />
      </HistoryItemTitle>
      <TimestampRow>{content}</TimestampRow>
    </HistoryItem>
  );
};
